import { Component, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AccordionPanel } from '@rogers/cdk/accordion';
import { ModalRef, ModalService,  ModalComponent as DsModalComponent, } from '@rogers/cdk/modal';
import { CookieService } from 'ngx-cookie-service';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { getIconBrandPrefix } from '../../shared/icon-brand-prefix';

@Component({
  selector: 'app-profile-pass-key-settings',
  templateUrl: './profile-pass-key-settings.component.html',
  styleUrl: './profile-pass-key-settings.component.scss',
  standalone: false
})
export class ProfilePassKeySettingsComponent  implements OnInit, OnDestroy {

  constructor(
  private modalService: ModalService,
  private viewContainerRef: ViewContainerRef,
  private readonly translate: TranslateService,
  private readonly cookieService: CookieService){}


  registeredPasskeys: PasskeyRegisteredDevices[];
  modalRef: ModalRef;
  client;
  iconPrefix: string;
  noPasskeyItem;
  warningMessage;
  showDeleteConfirmation: boolean = false;
  selectedPassKeyId;
  language: any;
  iosLink: string;
  andriodLink: string;
  chromeLink: string;
  edgeLink:string;
  safariLink: string;
  lang: string;

  onPasskeyRemoveSubmit: (payload: object) => void;
  onPasskeyRemoveCancel: () => void;

 accountModalAccordion : Array<AccordionPanel>;

  ngOnInit(): void {

    this.client  = this.cookieService.get('client');
    this.iconPrefix = getIconBrandPrefix(this.client);
    this.language = this.cookieService.get('lang');
    this.lang = this.language;

    this.getLinks();

    if (this.client === 'shaw'){
      this.noPasskeyItem = 'passkey.shaw.noPasskeyItem';
      this.warningMessage = 'passkey.shaw.warningMessage';
    }
    else if (this.client === 'shaw_direct'){
      this.noPasskeyItem = 'passkey.shawDirect.noPasskeyItem';
      this.warningMessage = 'passkey.shaw_direct.warningMessage';
    }
    else if (this.client === 'shaw_enterprise'){
      this.noPasskeyItem = 'passkey.shawEnterprise.noPasskeyItem';
      this.warningMessage = 'passkey.shaw_enterprise.warningMessage'
    }
    else{
      this.noPasskeyItem = 'passkey.profile.noPasskeyItem'
      this.warningMessage = 'passkey.profile.warningMessage'
    }

    this.accountModalAccordion =  [
    {
      header: this.translate.instant('passkey.profile.safe'),
      expandedAlt: '',
      collapsedAlt:'',
      expanded: false
    }
    ];

     this.translate.onLangChange
        .pipe(untilDestroyed(this))
        .subscribe((langEvent: LangChangeEvent) => {
          this.language = this.lang = langEvent.lang;
          this.getLinks();
      });

  //  var item : PasskeyRegisteredDevices = {
  //     PasskeyName: 'iCloud',
  //     Passkeylast_successful_authentication: '2026-08-29T14:59:28.118Z',
  //     Passkeyregistereddate: '2026-06-15T20:14:28.118Z',
  //     action: 'string',
  //     registeredPasskeyid: '11',
  //     passkey_provider_name: 'Windows'
  //  }

  //     var item2 : PasskeyRegisteredDevices = {
  //     PasskeyName: 'Windows',
  //     Passkeylast_successful_authentication: '2026-01-12T08:59:28.118Z',
  //     Passkeyregistereddate: '2026-11-14T07:11:28.118Z',
  //     action: 'string',
  //     registeredPasskeyid: '12',
  //     passkey_provider_name: 'Windows'
  //  }

  //  this.registeredPasskeys = [];
  //  this.registeredPasskeys.push(item);
  //  this.registeredPasskeys.push(item2);

   this.registeredPasskeys?.forEach(key => {
    key.en_created_date = this.formatDateTime(key.Passkeyregistereddate,'EN');
    key.fr_created_date = this.formatDateTime(key.Passkeyregistereddate,'FR');
    key.en_last_used = this.formatDateTime(key.Passkeylast_successful_authentication,'EN');
    key.fr_last_used = this.formatDateTime(key.Passkeylast_successful_authentication,'FR');
   });
  }
  
  openModal(templateRef: TemplateRef<DsModalComponent>) {
    this.modalRef = this.modalService.open(
      templateRef,
      this.viewContainerRef,
      { backdropClick: false }
    );
  }

  closeModal() {
    this.modalRef.close();
  }

  onCancelClick() {
    this.showDeleteConfirmation = false;
  }

  onCancelPasskeyClick(){
    this.onPasskeyRemoveCancel();
  }

  onPasskeyRemove(registeredPasskeyid) {
    this.selectedPassKeyId = registeredPasskeyid;
    this.showDeleteConfirmation = true;
  }

  confirmPasskeyDelete(){
    this.onPasskeyRemoveSubmit({'id': this.selectedPassKeyId});
  }

  getLinks(){

    this.iosLink = this.language === 'en' 
    ? 'https://support.apple.com/en-ca/guide/iphone/iphf538ea8d0/ios' 
    : 'https://support.apple.com/fr-ca/guide/iphone/iphf538ea8d0/ios';

    this.andriodLink = this.language === 'en' 
    ? 'https://support.google.com/accounts/answer/13548313?hl=en&sjid=6867787736020816167-NC#zippy=%2Cmissing-or-unavailable-passkey' 
    : 'https://support.google.com/accounts/answer/13548313?hl=fr&sjid=636958103724464611-NC';

    this.chromeLink = this.language === 'en' 
    ? 'https://support.google.com/chrome/answer/13168025?hl=en&co=GENIE.Platform%3DDesktop' 
    : 'https://support.google.com/chrome/answer/13168025?hl=fr&co=GENIE.Platform%3DDesktop&sjid=636958103724464611-NC';

    this.edgeLink = this.language === 'en' 
    ? 'https://support.microsoft.com/en-us/account-billing/create-and-save-a-passkey-e92cd3e0-11fa-4630-a5ea-3ccc0396b3d9' 
    : 'https://support.microsoft.com/fr-fr/account-billing/cr%C3%A9er-et-enregistrer-une-cl%C3%A9-d-acc%C3%A8s-e92cd3e0-11fa-4630-a5ea-3ccc0396b3d9';

    this.safariLink = this.language === 'en' 
    ? 'https://support.apple.com/en-ca/guide/iphone/iph37306ae67/ios' 
    : 'https://support.apple.com/fr-ca/guide/iphone/iph37306ae67/ios';
  }

  formatDateTime(dateInput: any, language:string): string {

    if (dateInput === null || dateInput === undefined || dateInput === '') {
        return ''; // or 'Invalid date'
    }

    let date: Date;
    date = new Date(dateInput);

    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
  
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const hours24 = date.getHours();
  
    // EN → 12-hour clock
    if (language === 'EN') {
      const hours12 = hours24 % 12 || 12;
      const ampm = hours24 >= 12 ? ' p.m' : ' a.m';
      return `${month} ${day}, ${year} , ${hours12}:${minutes}${ampm}.`;
    }
  
    // FR → 24-hour clock
    return `${day} ${month}. ${year}, ${hours24}h ${minutes}`;
  }

  ngOnDestroy(): void {}

}


interface PasskeyRegisteredDevices {
  PasskeyName: string;
  Passkeylast_successful_authentication: string;
  Passkeyregistereddate: string;
  action: string;
  registeredPasskeyid: string;
  passkey_provider_name: string;
  en_created_date?: string;
  fr_created_date?: string;
  en_last_used?: string;
  fr_last_used?: string;
}
